export abstract class RestResource {
  id = "0" // String, in the case of 'me' customer id

  get isCreated() {
    return this.id !== "0"
  }
}
